<template>
  <div class="wrapper">
    <Header />

    <main class="tech">
      <svg
        class="tech__picture"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M46.055 199.167h18.958a5.212 5.212 0 005.084-4.094l2.15-9.787a41.51 41.51 0 007.99-4.614l9.568 3.047a5.21 5.21 0 006.093-2.36l9.48-16.421a5.248 5.248 0 00-1.006-6.454l-7.421-6.77a42.197 42.197 0 000-9.23l7.421-6.77a5.246 5.246 0 001.006-6.454l-9.48-16.421a5.207 5.207 0 00-6.088-2.36l-9.573 3.047a41.058 41.058 0 00-3.73-2.443 42.765 42.765 0 00-4.265-2.177l-2.145-9.807A5.208 5.208 0 0065.013 95H46.055a5.208 5.208 0 00-5.084 4.099l-2.124 9.802a43.964 43.964 0 00-4.058 2.01 43.181 43.181 0 00-3.958 2.605l-9.568-3.047a5.21 5.21 0 00-6.094 2.359L5.69 129.25a5.24 5.24 0 001.005 6.458l7.422 6.756a42.188 42.188 0 000 9.229l-7.422 6.771a5.236 5.236 0 00-1.005 6.453l9.5 16.411a5.205 5.205 0 006.094 2.36l9.568-3.047a41.684 41.684 0 007.994 4.619l2.12 9.813a5.206 5.206 0 005.089 4.094zm-1.181-4.95v.003a1.209 1.209 0 001.18.947H65.01a1.212 1.212 0 001.18-.95v-.003l2.588-11.775 1.866-.817a37.61 37.61 0 007.22-4.17l1.643-1.211 11.511 3.666.002.001a1.204 1.204 0 001.414-.548l9.469-16.403.003-.007a1.245 1.245 0 00-.245-1.524l-8.909-8.128.223-2.022a38.188 38.188 0 000-8.354l-.223-2.022 8.914-8.132.004-.003a1.246 1.246 0 00.236-1.518l-.003-.006-9.469-16.402a1.21 1.21 0 00-1.412-.548l-11.512 3.664-1.641-1.206a36.972 36.972 0 00-3.365-2.204l-.008-.004-.008-.005a38.65 38.65 0 00-3.865-1.972l-1.855-.822-2.58-11.791A1.208 1.208 0 0065.01 99H46.058a1.208 1.208 0 00-1.178.95l-2.56 11.807-1.886.816a39.576 39.576 0 00-3.662 1.813 39.083 39.083 0 00-3.567 2.349l-1.642 1.212-11.515-3.667a1.204 1.204 0 00-1.414.547l-9.47 16.407-.004.006a1.237 1.237 0 00.237 1.518l.004.004 8.915 8.114-.223 2.025a38.188 38.188 0 000 8.354l.223 2.022-8.913 8.131-.004.004a1.236 1.236 0 00-.238 1.516l.004.007 9.49 16.394a1.205 1.205 0 001.414.548l.001-.001 11.512-3.666 1.642 1.21a37.648 37.648 0 007.228 4.177l1.873.82 2.549 11.8zm-6.92-64.693a24.83 24.83 0 0135.119 0 24.831 24.831 0 01-17.56 42.393 24.835 24.835 0 01-17.56-42.393zm2.828 2.828a20.834 20.834 0 1129.463 29.463 20.834 20.834 0 01-29.463-29.463z"
          fill="#000"
        />
        <path
          d="M164.129 145h-14.256c-.893 0-1.76-.304-2.456-.861a3.906 3.906 0 01-1.371-2.204l-1.594-7.348a31.408 31.408 0 01-6.012-3.459l-7.195 2.281a3.925 3.925 0 01-4.582-1.766l-7.144-12.289a3.913 3.913 0 01.756-4.832l5.581-5.07a31.435 31.435 0 010-6.911l-5.581-5.059a3.915 3.915 0 01-.756-4.836l7.128-12.296a3.913 3.913 0 011.979-1.688 3.932 3.932 0 012.604-.079l7.195 2.282a32.42 32.42 0 012.976-1.95 33 33 0 013.051-1.506l1.598-7.34a3.9 3.9 0 011.369-2.205 3.926 3.926 0 012.454-.864h14.256c.894 0 1.76.306 2.455.864a3.898 3.898 0 011.368 2.205l1.614 7.344a32.098 32.098 0 013.207 1.63c.968.558 1.904 1.17 2.805 1.83l7.199-2.282a3.93 3.93 0 012.601.08 3.91 3.91 0 011.977 1.686l7.128 12.297a3.914 3.914 0 01-.756 4.832l-5.581 5.07a31.435 31.435 0 010 6.911l5.581 5.07a3.915 3.915 0 01.756 4.832l-7.128 12.297a3.918 3.918 0 01-1.978 1.688 3.937 3.937 0 01-2.604.079l-7.195-2.282a31.306 31.306 0 01-6.008 3.455l-1.618 7.329a3.895 3.895 0 01-1.369 2.202 3.927 3.927 0 01-2.454.863zm-7.143-54.6a15.7 15.7 0 00-11.078 4.57 15.568 15.568 0 00-4.589 11.03c0 4.137 1.651 8.105 4.589 11.031a15.703 15.703 0 0011.078 4.569 15.7 15.7 0 0011.077-4.569A15.569 15.569 0 00172.652 106c0-4.137-1.651-8.105-4.589-11.03a15.699 15.699 0 00-11.077-4.57z"
          fill="#41AD49"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M83.123 87H98.88a4.35 4.35 0 002.712-.951 4.296 4.296 0 001.513-2.429l1.788-8.08a34.59 34.59 0 006.64-3.81l7.953 2.516a4.356 4.356 0 002.878-.087 4.318 4.318 0 002.186-1.86l7.879-13.559a4.311 4.311 0 00-.835-5.327l-6.169-5.59c.28-2.532.28-5.088 0-7.62l6.169-5.59a4.31 4.31 0 00.835-5.328l-7.879-13.558a4.319 4.319 0 00-2.184-1.859 4.357 4.357 0 00-2.876-.088l-7.957 2.515a34.015 34.015 0 00-3.099-2.017 35.448 35.448 0 00-3.546-1.797l-1.783-8.097a4.296 4.296 0 00-1.512-2.431A4.35 4.35 0 0098.88 1H83.123a4.347 4.347 0 00-2.713.953 4.296 4.296 0 00-1.512 2.431l-1.766 8.093a36.52 36.52 0 00-3.373 1.66 35.932 35.932 0 00-3.29 2.15l-7.952-2.516a4.356 4.356 0 00-2.878.087 4.321 4.321 0 00-2.187 1.86l-7.878 13.559a4.301 4.301 0 00.835 5.332l6.169 5.577a34.602 34.602 0 000 7.62l-6.169 5.59a4.3 4.3 0 00-.835 5.328l7.896 13.548a4.32 4.32 0 002.186 1.862 4.356 4.356 0 002.878.086l7.953-2.515a34.702 34.702 0 006.645 3.814l1.761 8.101a4.296 4.296 0 001.516 2.43c.769.615 1.726.95 2.714.95zM53.04 56.727l.002.004 7.886 13.532c.034.058.09.109.164.137a.356.356 0 00.235.007h.001l9.885-3.127 1.636 1.197a30.69 30.69 0 005.879 3.374l1.877.817 2.194 10.09.001.003c.014.06.049.12.106.165a.348.348 0 00.216.074h15.755a.348.348 0 00.216-.075.296.296 0 00.106-.166l2.229-10.074 1.87-.813a30.599 30.599 0 005.873-3.37l1.636-1.197 9.885 3.127h.001a.358.358 0 00.235-.006.317.317 0 00.163-.137l7.869-13.54.002-.004a.31.31 0 00-.066-.379l-.004-.003-7.668-6.949.225-2.032c.248-2.24.248-4.499 0-6.738l-.225-2.032 7.673-6.953.002-.002a.31.31 0 00.063-.377l-.002-.004-7.868-13.538M53.04 56.727a.301.301 0 01-.035-.193.317.317 0 01.1-.182c0-.001 0-.002.002-.003l7.672-6.952-.226-2.032a30.6 30.6 0 010-6.739l.226-2.034-7.674-6.938-.003-.003a.317.317 0 01-.098-.182.301.301 0 01.035-.195l7.872-13.545a.324.324 0 01.164-.138.356.356 0 01.234-.007l9.888 3.128 1.637-1.199a31.936 31.936 0 012.898-1.897 32.53 32.53 0 012.978-1.464l1.89-.812 2.205-10.098V5.24a.296.296 0 01.106-.165.347.347 0 01.215-.075h15.75c.082 0 .158.028.216.075a.295.295 0 01.106.167l2.221 10.083 1.859.817a31.584 31.584 0 013.146 1.595l.008.005.008.004c.939.54 1.852 1.136 2.735 1.78l1.635 1.193 9.884-3.125s.001 0 0 0a.361.361 0 01.235.007.326.326 0 01.163.137M75.922 29c3.999-3.973 9.417-6.2 15.062-6.2a21.376 21.376 0 0115.063 6.2c4 3.974 6.253 9.369 6.253 15a21.144 21.144 0 01-6.253 15c-4 3.973-9.418 6.2-15.063 6.2A21.375 21.375 0 0175.921 59a21.142 21.142 0 01-6.253-15 21.142 21.142 0 016.253-15zm2.818 2.838A17.375 17.375 0 0190.984 26.8c4.592 0 8.997 1.812 12.244 5.038A17.144 17.144 0 01108.3 44c0 4.562-1.825 8.937-5.072 12.162A17.375 17.375 0 0190.984 61.2a17.375 17.375 0 01-12.244-5.038A17.142 17.142 0 0173.668 44c0-4.562 1.825-8.937 5.072-12.162z"
          fill="#000"
        />
      </svg>

      <h1 class="tech__heading">Ведутся технические работы</h1>
      <p class="tech__text">Мы вернемся в ближайшее время.</p>
    </main>

    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';

export default {
  name: 'Maintenance',
  metaInfo: {
    title: 'Ведутся технические работы',
  },
  components: {
    Footer,
    Header,
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tech {
  flex: 1 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.tech__picture {
  width: 1em;
  height: 1em;
  font-size: 12rem;

  @media (min-width: 768px) {
    font-size: 15rem;
  }
}

.tech__heading {
  margin-top: 2rem;
  margin-bottom: 0;

  font-size: var(--fs-h3);
  font-weight: bold;
  text-align: center;

  @media (min-width: 768px) {
    font-size: var(--fs-h2);
  }
}

.tech__text {
  margin-top: 1rem;
  margin-bottom: 0;
  font-size: var(--fs-text-lg);
}
</style>
